<template>
  <div>
    <header class="mdc-top-app-bar top-app-bar top-header">
      <div class="mdc-top-app-bar__row">
        <section
          class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start"
        >
          <span class="mdc-top-app-bar__title t-subtitle4 pdl-12 cursor-pointer">{{title}}</span>
        </section>
        <section
          class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end"
          role="toolbar"
        >
          <div class="t-body2 t-color-white pdr-18"></div>
        </section>
      </div>
    </header>
    <div
      class="main-wrapper full flex-grow-1"
    >
      <div class="flex-grow-1 scroll-y pda-default container container--small pdt-50 pdb-50">
        <div class="t-headline5">{{ $t("3771") }}</div>
        <div class="mgt-8 t-body3 t-color-bodyGrayA">{{ $t("3772") }}</div>

        <div class="t-subtitle2 mgt-24">{{ $t("3773") }}</div>
        <div class="mgt-8">
          <div
            class="mdc-card mdc-elevation--z3 pda-default border-bottom-radius-default flex-row justify-content-between"
          >
            <div class="t-color-textfieldDisabledText t-body3">
              {{ $t("3774") }}
            </div>
            <div class="t-body3">{{ dormancyUserData.userId }}</div>
          </div>
          <div
            class="mdc-card mdc-elevation--z3 pda-default border-top-radius-default flex-row justify-content-between"
          >
            <div class="t-color-textfieldDisabledText t-body3">
              {{ $t("3775") }}
            </div>
            <div class="t-body3">
              {{ $moment(dormancyUserData.disposalDateTime).format("L") }}
            </div>
          </div>
        </div>

        <div class="mgt-50 d-flex flex-row">
          <button
            class="mdc-button mdc-button--raised bg-mainBtn mgr-8"
            @click="handleDisposeNextStep"
          >
            {{ $t("3776") }}
          </button>
          <button
            class="mdc-button btn-white mgr-8 mgl-8 t-color-secondaryBtnText"
            @click="handleClose"
          >
            {{ $t("3777") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapMutations, mapState } from "vuex";
import { topAppBarMixin } from "@/mixins/topAppBar";
import { userMixin } from "@/mixins/user";
import loginApi from "@/api/loginApi";

export default {
  name: "Dormancy",

  mixins: [topAppBarMixin, userMixin],

  data() {
    return {
      title: null,
    }
  },

  created() {
		// Redirect URL
		this.title = localStorage.getItem('brandName') || this.$t('1213')
	},

  mounted() {
    // dormancy user data 없으면 로그인 화면으로 이동
    if (!this.dormancyUserData) {
      return this.$router.replace({
        name: "Login",
      });
    }
    this.SET_JOINSTART(true);
    this.handleDormancyCondition();
  },

  computed: {
    ...mapState({
      dormancyUserData: (state) => state.dormancy.userData,
      dormancyConditions: (state) => state.dormancy.conditions,
    }),
  },

  methods: {
    ...mapMutations("join", ["SET_JOINSTART"]),

    ...mapMutations("dormancy", [
      "MUTATION_STATE_CATEGORY",
      "MUTATION_USER_DATA",
    ]),

    handleClose() {
      // 취소 모달 -> 취소 : 닫음 / 확인 : 로그인 창
      this.$confirm({
        title: this.$t("3778"),
        content: this.$t("3779"),
        accept: this.$t("3781"),
        cancel: this.$t("3780"),
      }).then(() => {
        this.$moveLogin();
      });
    },

    async handleDisposeNextStep() {
      try {
        const userParam = JSON.parse(localStorage.getItem("userParams"));
        const params = {
          userId: userParam.userId,
          password: userParam.password,
          device: userParam.device,
          id: this.dormancyUserData.disposalId,
        };

        if (userParam.hasOwnProperty("social")) {
          params["social"] = userParam.social;
        }

        const restoreResult = await loginApi.restoreDormancy(params);
        if (restoreResult && restoreResult.data) {
          /* 
              휴면해제 요청 후 프로세스 
              1. 새로 받아온 토큰값 헤더에 주입
              2. 새로 받아온 유저의 상태값 스토어에 업데이트
            */
          this.MUTATION_USER_DATA(restoreResult.data.data);
          loginApi.setAuthInHeader(restoreResult.data.data.token);
          this.checkUser();
        }
      } catch (error) {
        this.$router.replace({
          name: "Login",
        });
      }
    },

    handleDormancyCondition() {
      for (let condition in this.dormancyConditions) {
        this.MUTATION_STATE_CATEGORY({
          category: condition,
          value: this.dormancyUserData[condition],
        });
      }
    },
  },
};
</script>
  
  <style>
.border-bottom-radius-default {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.border-top-radius-default {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
</style>